export function formatDate(iso: string): string {
  const date = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  return date.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}

export function daysSince(iso: string | null): number | null {
  if (!iso) return null;
  const then = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso).getTime();
  return Math.floor((Date.now() - then) / (1000 * 60 * 60 * 24));
}
